import React from "react";
import style from "./QuestDuoxuan.module.scss";
import { Checkbox, Icon } from "antd";

interface QuestDuoxuanProps {
    index: number;
    correct: boolean;
    trunk: string;
    answers: {
        answerId: number;
        content: string;
        isRight: "0" | "1";
        isChoose: "0" | "1";
    }[];
}

export default function QuestDuoxuan({
    index,
    correct,
    trunk,
    answers
}: QuestDuoxuanProps) {
    return (
        <div className={style.root}>
            <div className={style.content}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: `${index + 1}.${trunk}`
                    }}
                />
            </div>

            <div className={style.RadioGroup}>
                {answers.map(item => (
                    <div key={item.answerId}>
                        <Checkbox
                            className={style.radio}
                            checked={item.isChoose === "1"}
                            value={item.answerId}>
                            <div
                                className={style.inlinblock}
                                dangerouslySetInnerHTML={{
                                    __html: item.content
                                }}
                            />
                        </Checkbox>
                    </div>
                ))}
            </div>

            {correct ? (
                <div className={`${style.result} ${style.right} globalISROOTS`}>
                    <Icon type="check" /> 正确
                </div>
            ) : (
                <div className={`${style.result} ${style.wrong} globalISROOTS`}>
                    <Icon type="close" /> 错误
                </div>
            )}
        </div>
    );
}
